import {
    canAccessAccounting,
    canAccessInventoryPortalItem,
    canAccessPurchaseModule,
    canAccessQCModule,
    canAccessSalesModule,
    canAccessToolingModule,
    canAccessEngineeringModule,
} from './roleConstants';

const INVENTORY_APPROVAL_ITEMS = [
    'master-raw-material',
    'master-finished-goods',
    'master-location',
    'activate-storage',
    'receiving-summary',
    'rm-transfer-summary',
    'fg-transfer-summary',
    'scrapping-summary',
];

const approvalRoutingModules = [
    {
        value: 'QC',
        label: 'Q-Value',
        description: ' (incoming, outgoing, in-progress, FPBO, LPBO, FAI)',
        canAccess: canAccessQCModule,
    },
    {
        value: 'inventory_management',
        label: 'Inventory Management',
        description: ' (scrap / variance approvals in the mobile app)',
        canAccess: (user) => INVENTORY_APPROVAL_ITEMS.some((item) => canAccessInventoryPortalItem(user, item)),
    },
    {
        value: 'Tooling',
        label: 'Tooling',
        description: ' (Tooling Maintenance Process approvals)',
        canAccess: canAccessToolingModule,
    },
    {
        value: 'Sales',
        label: 'Sales',
        description: ' (quotations, sales orders, invoices, delivery orders)',
        canAccess: canAccessSalesModule,
    },
    {
        value: 'Purchasing',
        label: 'Purchasing',
        description: ' (purchase orders)',
        canAccess: canAccessPurchaseModule,
    },
    {
        value: 'Finance & Accounting',
        label: 'Finance & Accounting',
        description: ' (purchase invoice, payment vouchers, credit notes, debit notes)',
        canAccess: canAccessAccounting,
    },
    {
        value: 'Engineering',
        label: 'Engineering',
        description: ' (Machinery, Jig & Fixture, and Tester maintenance approvals)',
        canAccess: canAccessEngineeringModule,
    },
];

export const getAccessibleApprovalRoutingModules = (user) =>
    approvalRoutingModules.filter((module) => module.canAccess(user));

export const canAccessApprovalRouting = (user) =>
    getAccessibleApprovalRoutingModules(user).length > 0;
